import styled from 'styled-components'

export const StyledRowArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  color: #6f7390;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
`

export const StyledValue = styled.span`
  letter-spacing: 0.2px;
`
